import React from 'react';
import PropTypes from 'prop-types';

import './canonical-form-option.scss';

function CanonicalFormOption(props) {
  const { isSelected, label, shouldResetFilter, suffix = '' } = props;
  let styleName = 'option';
  let message = '';

  if (isSelected) {
    styleName = 'option-selected';
  } else if (shouldResetFilter) {
    message = 'Selecting this may change other specs';
  }

  return (
    <div className="simple-option" styleName={styleName}>
      {label}
      {suffix}
      {message && <span styleName="message">{message}</span>}
    </div>
  );
}

CanonicalFormOption.propTypes = {
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  shouldResetFilter: PropTypes.bool,
  suffix: PropTypes.string
};

export default CanonicalFormOption;
